import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const LanguageSelector = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("language", value);
  };

  return (
    <Select defaultValue={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-[120px] h-[32px]">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="tr" className="flex items-center gap-2">
          <span className="fi fi-tr"></span> {t("Türkçe")}
        </SelectItem>
        <SelectItem value="en" className="flex items-center gap-2">
          <span className="fi fi-gb"></span> {t("English")}
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
